<template>
    <v-card>
        <v-toolbar dark color="primary">
            <v-btn icon dark :disabled="submitLoading" @click="cancel">
                <v-icon large>close</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-title>
                <span v-if="editing">Edit HMSKit</span>
                <span v-else>Add New HMSKit</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-form ref="editForm" v-model="editValid">
            <v-layout class="dialog-content">
                <v-flex xs12 md6 offset-md3 mt-4>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-text-field box clearable label="Asset Name" v-model="editData.Name" :rules="[
                                rules.required,
                                rules.maxfiftyCharacters
                            ]" counter>
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-textarea auto-grow box clearable label="Asset Description" v-model="editData.Description" :rules="[
                                rules.maxOneHundredCharacters
                            ]" counter>
                            </v-textarea>
                        </v-flex>
                        <v-flex xs12>
                            <v-autocomplete label="Plant" :items="plantList" item-value="PlantID" item-text="PlantName"
                                v-model="editData.PlantID" :rules="[
                                rules.required
                            ]" box chips clearable>
                            </v-autocomplete>
                        </v-flex>
                        <v-flex xs12>
                            <v-autocomplete :disabled="editing" label="Indicator" :items="indicatorList" item-value="IndicatorID"
                                item-text="IndicatorSeriesName" v-model="editData.IndicatorID" :rules="[
                                rules.required
                            ]" box chips clearable>
                            </v-autocomplete>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field box clearable label="Secret Key" v-model="editData.SecretKey" :rules="[
                                rules.required,
                                rules.maxthirtyCharacters
                            ]" counter>
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field box clearable label="Thumbprint" v-model="editData.Thumbprint" :rules="[
                                rules.required,
                                rules.maxfiftyCharacters
                            ]" counter>
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-checkbox label="Active" v-model="editData.IsActive">
                            </v-checkbox>
                        </v-flex>
                        <v-flex xs12>
                            <v-textarea auto-grow box clearable label="Comments" v-model="editData.Comments" :rules="[
                                rules.maxFiveHundredCharacters
                            ]" counter>
                            </v-textarea>
                        </v-flex>
                    </v-layout>
                    <v-layout wrap class="dialog-action-buttons">
                        <v-flex xs12 sm6>
                            <v-btn block color="success" :disabled="!editValid"
                                :loading="submitLoading" @click="submit">
                                <span>Save</span>
                            </v-btn>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-btn block color="error" :disabled="submitLoading" @click="cancel">
                                <span>Cancel</span>
                            </v-btn>
                        </v-flex>
                        <v-flex xs12>
                            <v-alert :value="submitError != null" outline type="error">
                                <span>{{ submitError }}</span>
                            </v-alert>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-form>
    </v-card>
</template>

<script>
import validationRules from "@/helpers/validationrules";

export default {
    components: {

    },
    props: {
        plantList: {
            required: true,
            type: Array
        },
        indicatorList: {
            required: true,
            type: Array
        },
        item: {
            required: true,
            type: Object
        },
        submitError: {
            required: false,
            type: String
        },
        submitLoading: {
            required: false,
            type: Boolean
        }
    },
    data() {
        return {
            rules: validationRules.rules,
            editData: {},
            editValid: false,
            error: null
        }
    },
    computed: {
        editing() {
            return this.editData.DeviceID != null;
        }
    },
    methods: {
        cancel() {
            this.$emit("cancel");
        },
        submit() {
            this.$emit("submit", this.editData);
        }
    },
    async created() {
        this.editData = JSON.parse(JSON.stringify(this.item));
    }
}
</script>